document.addEventListener('DOMContentLoaded', () => {
  // Add -centered class to formItem--email and form-actions elements
  const emailFormItem = document.querySelector(
    '.webform-submission-form-leadfolders-node-3397-form .formItem.formItem--email.formItem--e-mailadres, .webform-submission-form-leadfolders-node-3479-form .formItem.formItem--email.formItem--e-mailadres',
  );
  const formActions = document.querySelector(
    '.webform-submission-form-leadfolders-node-3397-form .form-actions.webform-actions.js-form-wrapper.form-wrapper, .webform-submission-form-leadfolders-node-3479-form .form-actions.webform-actions.js-form-wrapper.form-wrapper',
  );

  if (emailFormItem) {
    emailFormItem.classList.add('-centered');
  }

  if (formActions) {
    formActions.classList.add('-centered');
  }

  // Create the count display element
  const countDisplay = document.createElement('div');
  countDisplay.classList.add('-centered');
  document
    .querySelector(
      '.webform-submission-form-leadfolders-node-3397-form .formItem.formItem--email.formItem--e-mailadres, .webform-submission-form-leadfolders-node-3479-form .formItem.formItem--email.formItem--e-mailadres',
    )
    .parentNode.insertBefore(
      countDisplay,
      document.querySelector('.formItem.formItem--email.formItem--e-mailadres'),
    );

  const updateCount = () => {
    const checkedCount = document.querySelectorAll(
      '.formFieldGroup .formItem__input--checkbox:checked',
    ).length;

    if (checkedCount === 0) {
      countDisplay.innerHTML = 'Selecteer een of meerdere folders in de lijst hieronder.';
    } else if (checkedCount === 1) {
      countDisplay.innerHTML = 'Vul je e-mailadres in en ontvang de geselecteerde folder via mail.';
    } else {
      countDisplay.innerHTML = `Vul je e-mailadres in en ontvang de ${checkedCount} geselecteerde folders in je inbox.`;
    }
  };

  // Attach event listener to checkboxes
  document
    .querySelectorAll('.formItem__input--checkbox')
    .forEach((checkbox) => {
      checkbox.addEventListener('change', updateCount);
    });

  // Initial count update
  updateCount();
});
